interface OptOuts {
  /**
   * Name of the column(backend purpose)
   */
  physicalColumnName: string;
  /**
   * Name to display in UI
   */
  displayName: string;
  /**
   * Value
   */
  name: string;
}

/**
 * Method to add session storage
 * @param key Key of the storage
 * @param item item in the storage
 */
export function addToSessionStorage(key: string, item: string | null): void {
  if (sessionStorage && item) {
    sessionStorage.setItem(key, item);
  }
}

/**
 * Method to fetch session storage
 * @param storageKey key of the storage
 * @param fallbackValue value
 * @returns item
 */
export function getFromSessionStorage(storageKey: string, fallbackValue: any): any {
  if (!sessionStorage) {
    return fallbackValue;
  }
  return sessionStorage.getItem(storageKey) || fallbackValue;
}

/**
 * Method to delete from session storage
 * @param storageKey Key of the storage
 */
export function deleteFromSessionStorage(storageKey: string): void {
  if (sessionStorage) {
    sessionStorage.removeItem(storageKey);
  }
}

/**
 * Method to fetch the optOuts from session storage
 * @returns the optOuts name and display name
 */
export const getOptOuts: any = () => {
  const datamap = JSON.parse(getFromSessionStorage("query-builder-datamap", "{}"));
  if (datamap) {
    const optOutsOptions = datamap?.optOuts && datamap?.optOuts?.explorer_ipcv_vanilla;
    return optOutsOptions?.map((item: OptOuts) => {
      return {
        text: item.displayName,
        value: item.name
      };
    });
  }
};
